export const minutesInHour = 60;
export const hoursInDay = 24;
export const tenMinutes = 10;

export const dimensions = {
  tenMinutesHeightS: 10,
  tenMinutesHeightM: 15,
  tenMinutesHeightB: 20,
  timeLineWidth: 40,
  headerHeight: 50,
  groupedEventsMargin: 3,
};

export const colorScheme = {
  background: '#fff',
  divider: '#DCDCDC',
  hover: '#E6E6E6',
  header: '#F5F5F5',
};
